/**
 * The moment of the user's last activity, shared by every tab of this browser.
 *
 * `InactivityTimeoutService` records it and reads it back, so a tab that was left
 * open does not log the user out while they are working in another tab, and a tab
 * that is reloaded after the idle window has passed logs out right away instead of
 * resuming the session. `Auth0Service.logout` clears it so the next login starts fresh.
 *
 * Storage access can throw (private mode, blocked site data); the in-tab timer then
 * still applies and the server-side refresh token idle lifetime remains the backstop.
 */
const STORAGE_KEY = 'teamkeys.lastActivityAt';

export function recordActivity(at: number = Date.now()): void {
    try {
        localStorage.setItem(STORAGE_KEY, String(at));
    } catch {
        // storage unavailable: nothing to share between tabs
    }
}

export function lastActivityAt(): number | undefined {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        const at = stored === null ? Number.NaN : Number(stored);

        return Number.isFinite(at) ? at : undefined;
    } catch {
        return undefined;
    }
}

export function clearActivity(): void {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // storage unavailable: nothing to clear
    }
}
